var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"hot-offer-badge",attrs:{"src":(_vm.color && _vm.text) ? `${_vm.imageDomain}/assets/img/hot-offer-${_vm.color}.png`: `${_vm.imageDomain}/assets/img/hot-offer.png`,"width":"100","height":"100","alt":"hot-offer"}}),(_vm.text)?_c('p',{staticClass:"badge-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }